import { render, staticRenderFns } from "./addressModal.vue?vue&type=template&id=34992b52&scoped=true&"
import script from "./addressModal.vue?vue&type=script&lang=js&"
export * from "./addressModal.vue?vue&type=script&lang=js&"
import style0 from "./addressModal.vue?vue&type=style&index=0&id=34992b52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34992b52",
  null
  
)

export default component.exports